// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy__link[data-v-55019a44]{text-decoration:underline}`, "",{"version":3,"sources":["webpack://./src/components/Privacy.vue"],"names":[],"mappings":"AAEC,gCACC,yBAAA","sourcesContent":["\n.privacy {\n\t&__link {\n\t\ttext-decoration: underline;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
